import { Injectable } from "@angular/core";
import {
  MetaThemeColorService,
  NightModeService,
  PictureBackgroundService,
  ThemesService,
} from "@core";

@Injectable({ providedIn: "root" })
export class UiInitializationService {
  constructor(
    private _metaThemeColorService: MetaThemeColorService, // do not remove
    private _nightModeService: NightModeService,
    private _pictureBackgroundService: PictureBackgroundService,
    private _themesService: ThemesService,
  ) {}

  initializeUi(): void {
    this._nightModeService.initialSetupNightMode();
    this._pictureBackgroundService.initialSetupPictureBackground();
    this._themesService.initialSetupTheme();
  }
}
